<div *ngIf="isLoading" class="d-flex justify-content-center my-5">
  <div class="spinner-border text-warning" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div class="mainDiv">
  <div class="row">
    <div class="mainTxt d-flex justify-content-center mt-3" style="color: #f3a43f; font-size: 48px; font-weight: 500">
      Pending Transactions
    </div>
    <!-- <div class="search_Div mt-4 d-flex justify-content-center mb-4">
      <div class="search-container">
        <input type="text" placeholder="Search" [(ngModel)]="searchText" (keyup)="getPendingPayments(searchText)" />
        <span class="search-icon">🔍</span>
      </div>
    </div> -->
  </div>
<div class="card p-2" *ngIf="!isLoading">
    <div class="card-header">
      <h5>Pending Payments</h5>
      <!-- <div class="search-box">
          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="searchText"
            (keyup)="getBookingList(searchText)"
          />
          <i class="fas fa-search"></i>
        </div> -->
    </div>
    <div class="table-responsive" *ngIf="pendingPayments?.length != 0">
      <table class="table table-borderless">
        <thead>
          <tr>
            <!-- <th></th> -->
            <th>Sr. No.</th>
            <th>Choir Name</th>
            <th>No of kids</th>
            <th>Tax</th>

            <th>Amount</th>
            <!-- <th>Amount</th> -->

            <!-- <th>Event Date & Time</th>
            <th>No. of Kids</th>
            <th>Date of Bookings</th>
            <th>Amount Paid</th> -->
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let choir of pendingPayments; let i = index">
            <!-- <div class="form-check" style="cursor: pointer">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
              <label class="form-check-label" for="flexCheckDefault"> </label>
            </div> -->
            <td data-label="Sr. No.">{{ this.pagelimit * this.currentPage + i + 1 }}</td>
            <td data-label="Choir Name"> {{
              choir?.choirDetails?.title ? choir?.choirDetails?.title : "--"
              }}
            </td>
            <td data-label="No of Kids">{{ choir?.numberOfKids ? choir?.numberOfKids : "--" }}</td>
            <td data-label="Tax">${{ choir?.totalTaxes ? choir?.totalTaxes : 0 }}</td>
            <td data-label="Amount">${{ choir?.amount ? choir?.amount : "--" }}</td>
            <!-- <td>
              {{ convertSecondsToDate(item?.startDateInSeconds) }} ,
              {{ convertSecondsToTime(item?.startTimeInSeconds) }}
            </td>
            <td>{{ item?.numberOfKids ? item?.numberOfKids : "0" }}</td>
            <td>{{ convertSecondsToDate(item?.createdAt) }}</td>
            <td>${{ item?.totalAmount }}</td>
            <td #Btn (click)="OpenModal(userCheckoutScreen, Btn, item)">
              <img src="../../../../assets/images/info-circle.svg" style="cursor: pointer" />
            </td> -->
            <td data-label="">
              <span *ngIf="choir.status == 'expired' && !choir.isPendingPayment" class="expiredName">Expired</span>
              <span #Btn (click)="OpenModal(userCheckoutScreen, Btn, choir)"
                *ngIf="choir.status == 'pending' && choir.isPendingPayment" style="cursor: pointer">
                <button class="payBtn">Pay</button>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="row mt-5">
        <div class="col-md-4"></div>
        <div class="col-md-4" style="border-right: 1px solid #eeeeee"></div>
        <div class="col-md-4" style="padding: 20px">
          <span class="summary">Summary</span>

          <div class="row mt-2">
            <div class="col-6">Total</div>
            <div class="col-6">$2200</div>
          </div>
          <div class="row mt-2">
            <div class="col-6">Taxes</div>
            <div class="col-6">$220</div>
          </div>
          <div class="row mt-2">
            <div class="col-6">Grand Total</div>
            <div class="col-6">$2200</div>
            <div class="row">
              <div class="col-12 payBtnStyle">
                <button class="payBtn" (click)="payPayment()">Pay</button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="noPage" *ngIf="pendingPayments?.length == 0" style="
        min-height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
      ">
      <span class="noBookingTxt"> No Pending Payments Found</span>
    </div>
    <!-- <div class="totalPagintion d-flex">
      <div class="results-per-page">
        <span>Results per page: </span>
        <select
          class="form-control form-control-sm"
          style="width: 70px; margin-left: 10px"
          (change)="changePageLimit()"
          [(ngModel)]="pagelimit"
        >
          <option>5</option>
          <option>10</option>
          <option>15</option>
        </select>
      </div>
      <div class="col-md">
        <div class="form-group pagination mt-2" style="float: right">
          <div class="pagination">
            <div class="pagination-box" (click)="prevPage()" [ngClass]="{ disabled_pagination: currentPage == 0 }">
              <
            </div>
            <div class="pagination-box">{{ currentPage + 1 }} / {{ totalPage }}</div>
            <div
              class="pagination-box"
              (click)="nextPage()"
              [ngClass]="{
                disabled_pagination: currentPage + 1 == totalPage
              }"
            >
              >
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item"><a class="page-link" href="#">Previous</a></li>
          <li class="page-item"><a class="page-link" href="#">1</a></li>
          <li class="page-item"><a class="page-link" href="#">2</a></li>
          <li class="page-item"><a class="page-link" href="#">3</a></li>
          <li class="page-item"><a class="page-link" href="#">...</a></li>
          <li class="page-item"><a class="page-link" href="#">8</a></li>
          <li class="page-item"><a class="page-link" href="#">9</a></li>
          <li class="page-item"><a class="page-link" href="#">Next</a></li>
        </ul>
      </nav> -->
  </div>
</div>
<ng-template #userCheckoutScreen let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>

  <!-- Modal Header -->
  <div class="modal-header">
    <h5 class="modal-title">Summary</h5>
    <div class="crossIcon">
      <img src="../../../../assets/images/purple-cross.svg" style="cursor: pointer" data-dismiss="modal"
        (click)="closeModal('dismiss')" />
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <div class="summary-section">
      <table class="summary-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Gender</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of kidsDetail">
            <td>{{ item?.firstName ? item?.firstName : "--" }}</td>
            <td>{{ item?.age ? item?.age : "--" }}</td>
            <td>{{ item?.gender ? item?.gender : "--" }}</td>
            <!-- (click)="OpenModal(userCheckoutScreen, Btn, choir)" -->
            <!-- (click)="OpenRemoveModal(removeKidScreen, bn, item)" -->
            <td (click)="removeKid(item)">
              <img src="../../../../assets/images/minus-cirlce.svg" alt="" style="cursor: pointer" />
            </td>
          </tr>
          <!-- <tr>
                <td>Kelly Jay</td>
                <td>15</td>
                <td>Male</td>
              </tr> -->
        </tbody>
      </table>
      <div class="couponDiv mb-4">
  <input type="text" class="form-control form_Input" [(ngModel)]="CouponCode"
    [ngModelOptions]="{ standalone: true }" required placeholder="Enter Coupon Code"
    [disabled]="isAppliedCode == true" />
  <button *ngIf="!isAppliedCode" class="btn btn-Login2" (click)="applyCode()" [disabled]="CouponCode == ''">
    Apply Code
  </button>
  <button *ngIf="isAppliedCode" class="btn btn-Login2" (click)="removeCode()">
    Remove Code
  </button>
</div>

      <p class="paymentTxt">Pending Payment Detail</p>
      <div class="payment-summary">
        <div class="summary-item">
          <span>Total</span>
          <span>${{ pendingPayments1?.amount?.toFixed(2) }}</span>
        </div>
        <div class="summary-item">
          <span>Taxes</span>
          <span>${{ pendingPayments1?.totalTaxes?.toFixed(2) }} </span>
        </div>
        <div class="summary-item" *ngIf="isAppliedCode || discountData" style="color: red">
          <span>Discount</span>
          <span>-${{ discountData.toFixed(2) }} </span>
        </div>

        <div class="summary-item grand-total">
          <span>Grand Total</span>
          <span>${{ pendingPayments1?.totalAmount?.toFixed(2) }}</span>
        </div>
        <div class="" style="text-align: end; margin-top: 30px">
          <button class="payBtnn" (click)="payPayment()">Checkout</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Footer -->
  <!-- <div class="modal-footer" style="justify-content: center">
        <button class="btn btn-Login" (click)="saveBooking()">
          Checkout <img src="../../../../assets/images/IconRightturn.svg" />
        </button>
      </div> -->
</ng-template>
<ng-template #removeKidScreen let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>

  <!-- Modal Header -->
  <div class="modal-header">
    <h5 class="modal-title">Remove Kid</h5>
    <div class="crossIcon">
      <img src="../../../../assets/images/purple-cross.svg" style="cursor: pointer" data-dismiss="modal"
        (click)="closeModal('dismiss')" />
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <div class="summary-section">
      Are you sure ? You want to remove this kid!
    </div>
  </div>
  <div class="modal-footer">
    <div class="" style="width: 30%">
      <Button class="payBtn" (click)="removeKid()">Yes</Button>
    </div>
    <div class="" style="width: 30%">
      <Button class="payBtn" (click)="closeModal('dismiss')">No</Button>
    </div>
    <!-- 
    <div class="row">
      <div class="col-6"><Button class="payBtn" (click)="removeKid(item)">Yes</Button></div>
      <div class="col-6"><Button class="payBtn" (click)="closeModal('dismiss')">No</Button></div>
    </div> -->
  </div>

  <!-- Modal Footer -->
  <!-- <div class="modal-footer" style="justify-content: center">
        <button class="btn btn-Login" (click)="saveBooking()">
          Checkout <img src="../../../../assets/images/IconRightturn.svg" />
        </button>
      </div> -->
</ng-template>
